<template>
  <div class="container">
    <div class="mt-2 card">
      <PatientInfo v-if="patient_id" :patient_id="patient_id">
        <template v-slot:action-bt>
          <button
            @click="showAddDiagnosisModal"
            class="mycustom-success-button"
          >
            Add Diagnosis
          </button>
        </template>
      </PatientInfo>
    </div>

    <div class="mt-2 card">
      <table class="table align-items-center mb-0">
        <thead>
          <tr style="color: black">
            <th>#</th>
            <th>Diagnosis</th> 
            <th>Type</th>
            <th>Stage</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(diag, index) in diagnoses" :key="diag.id">
            <th>{{ index + 1 }}</th>
            <td>{{ diag.diagnosis }}</td>
            <td>{{ diag.diagnosis_type }}</td>
            <td>{{ diag.diagnosis_stage }}</td>
            <td>
              <button
                class="btn btn-sm btn-danger button-touch"
                @click="deleteDiagnosis(diag.id)"
              >
                Delete
              </button>
              <!-- <button
                class="btn btn-sm btn-info button-touch"
                @click="viewDiagnosis(diag)"
              >
                View
              </button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Example AddDiagnosisModal -->
  <AddDiagnosisModal
    v-if="showAddDiagnosis"
    :visit_id="visit_id"
    @close-add-diagnosis-modal="closeDiagMod"
    @refresh-diagnoses="fetchDiagnoses"
  />
</template>

<script>
import PatientInfo from "../Patients/components/patient_biodata.vue";
import { generalApiRequest } from "../../api/apiIndex.js";
import AddDiagnosisModal from "./diagnosis/AddDiagnosisModal.vue";

export default {
  name: "DiagnosisDashboard",
  components: {
    PatientInfo,
    AddDiagnosisModal,
  },
  data() {
    return {
      visit_id: this.$route.params.visitid,
      patient_id: null,
      diagnoses: [],
      showAddDiagnosis: false,
    };
  },
  methods: {
    closeDiagMod() {
      this.showAddDiagnosis = false;
      this.fetchDiagnoses();
    },
    async get_patient_id_from_visit() {
      var body = {
        visit_id: this.visit_id,
      };
      const res = await generalApiRequest(
        "get_patient_id_from_visit",
        "GET",
        body,
        1
      );

      this.patient_id = res.data;
      console.log(res);
    },
    showAddDiagnosisModal() {
      this.showAddDiagnosis = true;
    },

    async fetchDiagnoses() {
      try {
        const res = await generalApiRequest(
          "get_diagnoses_for_visit",
          "GET",
          {
            visit_id: this.visit_id,
          },
          1
        );

        this.diagnoses = res.data;
        console.log(res);
      } catch (error) {
        console.error("Failed fetching diagnoses:", error);
      }
    },

    async deleteDiagnosis(id) {
      if (!confirm("Are you sure you want to delete this diagnosis?")) return;
      try {
        const res = await generalApiRequest(
          `delete_diagnosis/${id}`,
          "GET",
          {},
          1
        );
        if (res.status === "success") this.fetchDiagnoses();
      } catch (error) {
        console.error("Failed deleting diagnosis:", error);
      }
    },

    viewDiagnosis(diagnosis) {
      alert(
        `Diagnosis: ${diagnosis.diagnosis}\nType: ${diagnosis.diagnosis_type}\nStage: ${diagnosis.diagnosis_stage}`
      );
    },

    async mountVisitInfo() {
      const res = await generalApiRequest(
        "get_all_visits_dates",
        "GET",
        { visit_id: this.visit_id },
        1
      );
      if (res.data.length > 0) this.patient_id = res.data[0].patient_id;
    },
  },
  mounted() {
    this.get_patient_id_from_visit();
    this.mountVisitInfo();
    this.fetchDiagnoses();
  },
};
</script>
